import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TerraUtils } from '../shared/TerraUtils';

@Component({
  selector: 'terra-account',
  template: `
    <router-outlet></router-outlet>
  `,
  styleUrls: ['./account.component.scss']
})
export class AccountComponent implements OnInit {

  constructor(
    private titleService: Title
    ) {}

  ngOnInit() {

    this.titleService.setTitle('My Account' + TerraUtils.consts.GpPageTitleSuffix);
  }
}
